import { jsx as _jsx } from "react/jsx-runtime";
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import { ErrorBoundary } from "react-error-boundary";
import useGetCampaignFeatures from "pages/campaign/hooks/useGetCampaignFeatures";
import FeaturedBy from "./FeaturedBy";
// Preserves any query params (and fragment) already present on paymentUrl (e.g. the
// fundraiser "?f=" param) instead of blindly appending a second "?".
const withFeaturedByUtm = (paymentUrl, featureId) => {
    const url = new URL(paymentUrl);
    url.searchParams.set("utm_source", "featuredby");
    url.searchParams.set("utm_content", featureId);
    return url.toString();
};
const FeaturedByWrapper = ({ campaign, paymentUrl }) => {
    const { featuredByLinks, loading, error, } = useGetCampaignFeatures({ campaignId: campaign.id });
    if (!featuredByLinks || featuredByLinks.length === 0 || loading || error) {
        return null;
    }
    const featuredLink = featuredByLinks[0];
    const paymentUrlWithUtm = withFeaturedByUtm(paymentUrl, featuredLink.id);
    return (_jsx(ErrorBoundary, { fallback: _jsx(ErrorFallback, { error: error }), children: _jsx("div", { className: "campaign-container__featured-by-wrapper", children: _jsx(FeaturedBy, { featuredByLink: featuredByLinks[0], paymentUrl: paymentUrlWithUtm }) }) }));
};
export default FeaturedByWrapper;
